module.exports = __webpack_public_path__ + "static/media/P2trans2.d77a8625.png";